module.exports = __webpack_public_path__ + "media/images/general/sns/logo-youtube-04fd2c03fbb15e38c660308f86e7d376.svg";